export default __webpack_public_path__ + "static/media/uae-dirham.132ff4f1.svg";